import React from 'react';
import logo from '../../assets/Images/LOGOS/Docity_Logo_updatedDocity_Colored_Emblem.png';
import './DocitySeal.css';

/**
 * The DoCity Seal.
 *
 * Lifted out of KYPList.jsx, where it was inline SVG duplicated twice (once for
 * the ownership certificate, once for the voucher). It is the product's single
 * strongest mark of authority, so it belongs in a component that any screen can
 * use rather than buried in one list view.
 *
 * @param size   px. The arcs are drawn in a 200x200 viewBox and scale with it.
 * @param code   optional unique seal code, announced to assistive tech.
 * @param muted  renders in outline only, for use as a background watermark.
 */
const DocitySeal = ({ size = 120, code, muted = false, className = '' }) => {
  /* Unique ids per instance: two seals on one page would otherwise share
     textPath targets, and the second would render its text along the first. */
  const uid = React.useId().replace(/:/g, '');
  const topArc = `sealTop-${uid}`;
  const bottomArc = `sealBottom-${uid}`;

  return (
    <span
      className={`docity-seal${muted ? ' docity-seal--muted' : ''} ${className}`.trim()}
      style={{ width: size, height: size }}
      role="img"
      aria-label={code ? `DoCity seal, reference ${code}` : 'DoCity seal'}
    >
      <svg viewBox="0 0 200 200" className="docity-seal__svg" aria-hidden="true" focusable="false">
        <defs>
          <path id={topArc} d="M 28 100 A 72 72 0 0 1 172 100" />
          <path id={bottomArc} d="M 172 100 A 72 72 0 0 1 28 100" />
        </defs>

        <circle cx="100" cy="100" r="94" className="docity-seal__ring-outer" />
        <circle cx="100" cy="100" r="88" className="docity-seal__ring-hair" />
        <circle cx="100" cy="100" r="62" className="docity-seal__ring-mid" />

        <text className="docity-seal__arc">
          <textPath href={`#${topArc}`} startOffset="50%" textAnchor="middle">
            DOCITY.CO.IN
          </textPath>
        </text>
        <text className="docity-seal__arc">
          <textPath href={`#${bottomArc}`} startOffset="50%" textAnchor="middle">
            THE DOCITY SEAL
          </textPath>
        </text>

        <text x="100" y="82" className="docity-seal__word" textAnchor="middle">
          VERIFIED
        </text>
        <image
          href={logo}
          x="80"
          y="88"
          width="40"
          height="40"
          preserveAspectRatio="xMidYMid meet"
        />
        {code && (
          <text x="100" y="142" className="docity-seal__code" textAnchor="middle">
            {code}
          </text>
        )}
      </svg>
    </span>
  );
};

export default DocitySeal;
